import React, {useState, useEffect, useCallback} from 'react';
import {useMap} from "react-leaflet";

import ReactPortal from "../Utils/ReactPortal";

// import Swiper core and required modules
import SwiperCore, { Mousewheel } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// import Swiper styles
import 'swiper/swiper-bundle.css';

import './StoresList.css'
import StoreListContainer from "./StoreListContainer";
import DataHook from "../dataHook/dataHook";
import useMenuSide from "../../hooks/useMenuSide";
import Flaticon from "../flaticon/flaticon";

// install Swiper modules
SwiperCore.use([Mousewheel]);

/**
 * Get the map in bound markers from the markerList
 * @param map
 * @param storesList
 * @returns {*|boolean}
 */
const getVisibleMarkers = (map,storesList) => {
    const visibleMarkersList = storesList.filter((e,i) => (e.sl_lat || e.sl_lng ? map.getBounds().contains([e.sl_lat,e.sl_lng]) : false));
    return visibleMarkersList.length > 0 ? visibleMarkersList : false
}

/**
 * Return in map bound visual markers list
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const LocatorList = (props) => {
    const settings = props.settings
    const singular_text = settings ? settings.singular ? settings.singular : '...' : '...'
    const plural_text = settings ? settings.plural ? settings.plural : '...' : '...'

    const map = useMap()
    const [visibleMarkersList, setVisibleMarkersList] = useState([])
    const [isOpenSwiperMenu, setIsOpenSwiperMenu] = useState(false)
    const menuSide = useMenuSide()

    //Get store list from props
    const storesList = useCallback(() => {
        return props.storesList ? props.storesList : []
    },[props.storesList])

    useEffect(() => {
        //fill markerList with map visible markers
        const visibleMarker = () => {
            const theVisibleMarker = getVisibleMarkers(map,storesList())

            if (theVisibleMarker && typeof theVisibleMarker !== 'undefined') {
                setVisibleMarkersList(theVisibleMarker);
            } else {
                setVisibleMarkersList([]);
            }

        }


        //On movement end (drag, zoom etc..) on the leaflet map check for visible markers
        map.on('moveend', visibleMarker)
        map.invalidateSize()
        //init visible markers
        visibleMarker()

        return () =>{
            map.off('moveend', visibleMarker)
        }

    }, [map,storesList])

    //Init Swiper.js parameters
    const params = {
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: {
            invert: false,
            sensitivity:0.5
        },
        direction:'vertical',
        breakpoints:{
            768: {
                direction: menuSide ? 'vertical' : 'horizontal'
            }
        }
    }

    const handleSwiperMenuButtonClick = (e) => {
        e.preventDefault()
        if (!isOpenSwiperMenu)
            setIsOpenSwiperMenu(true)
        else
            setIsOpenSwiperMenu(false)
    }
    const SwiperMenuButton = () => {
        return (
            <div onClick={handleSwiperMenuButtonClick}>
                <div className={'show-swiper-button-icon'}>
                    {isOpenSwiperMenu ?
                        <i className="fas fa-times"/>
                        :
                        <i className="fas fa-chevron-up"/>
                    }
                </div>
            </div>

        )
    }
    /**
     * Show the visibles stores list
     * @param props
     * @returns {JSX.Element}
     * @constructor
     */
    const StoreLocatorListSwiper = (props) => {
        return (
            <Swiper {...params} >
                {visibleMarkersList.map((e, i) => {
                    return (
                        <SwiperSlide className={`marker-list-item ${menuSide ? 'side-marker-list' : ''}`} key={`StoreLocatorContainer-${e.id}`}>
                            <a itemProp={'url'} className={'marker-list-item-link'} href={e.link}>
                            </a>
                            <div itemScope={true} itemType={'https://schema.org/LocalBusiness'} className={'marker-list-item-container'}>
                                <div className={'marker-list-item-content'}>
                                    <h3 itemProp={'name'}>{e.title.rendered}</h3>
                                    <span itemProp={'address'} >{e.sl_address}</span>
                                    <div className={'marker-list-item-content-append'}>
                                        <DataHook key={`dataHook-${e.id}`} hooks={e['sl_hook'] ? e['sl_hook'] : false} position={'after_content_card'}/>
                                    </div>
                                </div>
                                <div className={'marker-list-item-thumbnail'}>
                                    {e.sl_preview ?
                                        <img loading={'lazy'} itemProp={'image'} src={e.sl_preview.large[0]} alt={e.sl_preview.alt}/>
                                        :
                                        <img itemProp={'image'} src={'https://via.placeholder.com/600/000000/f0b849?text=No+image'} alt=""/>
                                    }
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        )
    }

    return (

        <>
            <ReactPortal id={'marker-list-button'}>
                <div id={`show-swiper-button`} className={`test ${isOpenSwiperMenu ? 'show-swiper-button-open' : ''}`} >
                    <SwiperMenuButton/>
                </div>
            </ReactPortal>

            <StoreListContainer isLoading={false} visibleMarkersListLength={visibleMarkersList.length} isOpenSwiperMenu={isOpenSwiperMenu}>
                {(visibleMarkersList.length > 0) ?
                    <StoreLocatorListSwiper/>
                    :
                    <div className={'loading-locator-list'}>
                        <Flaticon icon={'magnifier'}/>
                        <span>Aucun {singular_text} dans cette zone...</span>
                    </div>
                }
            </StoreListContainer>
        </>
    );
}

export default LocatorList;